<template>
  <div
    :style="
      pickupScreenFirstBorder +
      `
        border-width: 2px !important;
        --highlightColor: ${customThemeVariables['pickup-screen-first--border']}
      `
    "
    :class="[
      'flex items-center  highlight',
      isReady ? 'rounded-xl mr-6 mb-6' : 'rounded-xl mr-6 mb-6',
      isReady ? 'px-6 py-2 h-24' : 'px-4 py-5 h-24',
    ]"
  >
  <span v-if="!menu.is_collection_code_enabled" class="flex">
    <span
      :class="[
        'font-light',
        isReady ? 'text-2xl' : 'text-xl',
        isReady ? 'mr-5' : 'mr-3',
      ]"
      :style="pickupScreenFirstOrderNumber"
    >
      #{{ data["Order"].Id }}
    </span>
    <span
      :class="[
        'font-medium leading-7 capitalize whitespace-no-wrap truncate pr-12',
        isReady
          ? 'text-5xl h-full flex items-center'
          : 'text-4xl h-full flex items-center',
      ]"
      :style="pickupScreenFirstNameColor"
      >{{ initials }}</span
    >
    </span>
    <span v-if="menu.is_collection_code_enabled"
      :class="[
        'font-medium leading-7 capitalize whitespace-no-wrap truncate px-6',
        isReady
          ? 'text-5xl h-full flex items-center'
          : 'text-4xl h-full flex items-center',
      ]"
      :style="pickupScreenFirstNameColor"
      >{{ data["Order"].CollectionCode }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { minutes } from "../utils";

export default {
  props: {
    data: Object,
    index: Number,
  },
  computed: {
    ...mapGetters(["menu"]),
    ...mapGetters("Theme", [
      "customThemeVariables",
      "pickupScreenFirstBorder",
      "pickupScreenFirstNameColor",
      "pickupScreenFirstOrderNumber",
    ]),
    isReady() {
      return this.data["Order"].isPrepared;
    },
    initials() {
      // Get the customers' name
      const name = this.data["Customer"].fullName;

      /**
       * Split the name based on used spaces
       * Retrieve the (presumably) first name, and collect the last name(s) as an array by destructuring
       */
      const [first, ...more] = name.split(" ");

      // Get first letter from each last name item and join by a point and space
      const last = more.reduce((acc, curr) => acc + `${curr.charAt(0)}. `, "");

      return `${first} ${last}`;
    },
  },
};
</script>

<style scoped>
.highlight {
  animation-name: example;
  animation-duration: 1s;
}

@keyframes example {
  from {
    background-color: var(--highlightColor);
  }
  to {
    background-color: inherit;
  }
}
</style>
